module.exports = __webpack_public_path__ + "img/lr.bc734b2a.svg";